
export function stringToDate(dateString: string) {
    return (new Date(`${dateString}Z`)).toLocaleDateString();
}

export function stringToDateTime(dateString: string) {
    return (new Date(`${dateString}Z`)).toLocaleString();
}